import {
	AbstractControl,
	ValidationErrors,
	ValidatorFn,
	FormBuilder,
	FormGroup,
	Validators,
} from '@angular/forms';
import { rutValidate } from 'rut-helpers';
import { Patterns, SEQUENTIAL_NUMBER } from './constants';
import { isLegalEntity } from './utils';
import { CustomerDataUI } from '../interfaces/customer-data.interface';
import { PurposeUI } from '../interfaces/get-purposes';

export function rutValidator(): ValidatorFn {
	return (control: AbstractControl): ValidationErrors | null => {
		const rut = control.value;
		if (!rut) return null;
		return rutValidate(rut) ? null : { invalidRut: true };
	};
}

export function naturalPersonValidator(): ValidatorFn {
	return (control: AbstractControl): ValidationErrors | null => {
		const rut = control.value;
		if (!rut) return null;
		return isLegalEntity(rut) ? { notNaturalPerson: true } : null;
	};
}

export function emailRegexValidator(): ValidatorFn {
	const regex = Patterns.email;
	return (control: AbstractControl): ValidationErrors | null => {
		const email = control.value;
		if (!email) return null;
		return regex.test(email) ? null : { invalidEmail: true };
	};
}

export function differentPhoneValidator(currentPhone: string): ValidatorFn {
	return (control: AbstractControl): ValidationErrors | null => {
		if (!control.value) return null;
		return control.value === currentPhone ? { samePhone: true } : null;
	};
}

export function phoneValidationsRegex(): ValidatorFn {
	return (control: AbstractControl<string | null>): ValidationErrors | null => {
		const value = control.value;
		if (!value) return null;

		const phoneNumber = value.slice(-8);
		const isInvalid =
			hasSameRepeatedDigit(phoneNumber) ||
			isSequentialNumber(phoneNumber) ||
			hasRepeatedTwoDigitPattern(phoneNumber);

		return isInvalid ? { invalidPhone: true } : null;
	};
}

function hasSameRepeatedDigit(value: string): boolean {
	return Patterns.repeatDigits.test(value);
}

function isSequentialNumber(value: string): boolean {
	return SEQUENTIAL_NUMBER.ASCENDING.includes(value) || SEQUENTIAL_NUMBER.DESCENDING.includes(value);
}

function hasRepeatedTwoDigitPattern(value: string): boolean {
	return Patterns.twoDigitsRepeated.test(value);
}

export function ensureUserRut(customerData: CustomerDataUI) {
	return {
		...customerData,
		userRut: customerData.userRut || customerData.companyRut,
	};
}

export function buildPrivacyTermsGroup(list: PurposeUI[], fb: FormBuilder): FormGroup {
	const group = fb.group({});
	list.forEach(purpose => {
		group.addControl(
			purpose.id,
			fb.nonNullable.control(false, purpose.mandatory ? Validators.requiredTrue : [])
		);
	});
	return group;
}

export function createUserRutControl(fb: FormBuilder): AbstractControl {
	return fb.nonNullable.control('', {
		validators: [
			Validators.required,
			Validators.maxLength(12),
			rutValidator(),
			naturalPersonValidator(),
		],
	});
}
